export default __webpack_public_path__ + "static/media/numberCircle.79e52f74.svg";